export default {
  competitor_page_title: 'Competitor',
  competitor_page_xh_title: 'Competitor-excl.smurf',
  competitor_tab_key_metrics: 'Key Metrics',
  competitor_tab_insight: 'Insight',
  competitor_time_switch_text: 'Aligned by launch time / earliest date',
  competitor_time_switch_desc: 'The chart ignores the date when the switch is enabled. Please re-select date filter aligned by launch time or earliest date, with the earliest date time being based on the new user.',
  competitor_launch: 'Launch Time',
  competitor_earliest_data: 'Earliest Date',
  competitor_launch_Day: 'Day',
  competitor_launch_Month: 'Month',
  competitor_competitor: 'Competitor',
  competitor_competitor_last_one_message: 'This option is the last one, after unchecking the competitor game will not have data.',
  competitor_source: 'Source',
  competitor_key_metrics_trend_title: 'Key Metric Trends',
  competitor_key_metrics_dau_trend_title: 'DAU Trends',
  competitor_key_metrics_agv_dau_trend_title: 'Avg.DAU Trends',
  competitor_key_metrics_agv_mau_trend_title: 'Avg.MAU Trends',
  competitor_key_metrics_wau_trend_title: 'WAU Trends',
  competitor_key_metrics_mau_trend_title: 'MAU Trends',
  competitor_key_metrics_revenue_trend_title: 'Revenue Trends',
  competitor_key_metrics_revenue_trend_tab1: 'Revenue',
  competitor_key_metrics_revenue_trend_tab2: 'Adjusted Revenue',
  competitor_key_metrics_adjusted_revenue_desc: `Adjusted Revenue= Data.ai Revenue/0.7<br/>Adjustments were made because the revenue of Data.ai don't include channel cost.`,
  competitor_key_metrics_new_trend_title: 'New Trends',
  competitor_key_metrics_retention_trend_title: 'Retention Trends',
  competitor_key_metrics_retention_no_data: `There is no retention data,when doing statistics by day or by week,<br/>please switch to month and view retention trends.`,
  competitor_key_metrics_performance_title: 'Key Metrics Performance',
  competitor_key_metrics_performance_date: 'Date',
  competitor_key_metrics_performance_launch_date: 'Launch Date',
  competitor_key_metrics_performance_game: 'Game',
  competitor_key_metrics_performance_revenue: 'Revenue({unit})',
  competitor_key_metrics_performance_adjusted_revenue: 'Adjusted Revenue({unit})',
  competitor_key_metrics_performance_adjusted:'Adjusted Revenue({unit})',
  competitor_key_metrics_performance_dau: 'DAU',
  competitor_key_metrics_performance_avg_dau: 'Avg.DAU',
  competitor_key_metrics_performance_wau: 'WAU',
  competitor_key_metrics_performance_mau: 'MAU',
  competitor_key_metrics_performance_new: 'NEW',
  competitor_key_metrics_performance_d2: 'Avg.D2',
  competitor_key_metrics_performance_d3: 'Avg.D3',
  competitor_key_metrics_performance_d7: 'Avg.D7',
  competitor_key_metrics_performance_d15: 'Avg.D15',
  competitor_key_metrics_performance_d31: 'Avg.D31',
  competitor_key_metrics_performance_tru: 'TNU',
  competitor_key_metrics_performance_total_revenue: 'Total Revenue({unit})',


  competitor_insight_competitive_comparison_title: 'Competitive comparison',
  competitor_insight_competitive_comparison_module1_title: 'Revenue({unit}) & Active',
  competitor_insight_competitive_comparison_module1_y_lable: 'Revenue',
  competitor_insight_competitive_comparison_module1_x_lable:'Active',
  competitor_insight_competitive_comparison_module1_x_previous:'Previous',
  competitor_insight_competitive_comparison_module1_sum: 'Sum',
  competitor_insight_competitive_comparison_module1_avg:' Avg.',

  competitor_insight_competitive_comparison_module2_title: 'New & Retention D2',
  competitor_insight_competitive_comparison_module2_y_lable: 'D2',
  competitor_insight_competitive_comparison_module2_x_lable:'New',
  competitor_insight_competitive_comparison_module2_no_data: `There is no retention data,when doing statistics by day or by week,<br/>please switch to month and analyze the relationship between new and retention.`,
    
}